"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modalIcon;

// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
function modalIcon(callback) {
  var _this = this;

  var h = this.$createElement;
  return new Promise(function (resolve, reject) {
    _this.$msgbox({
      title: '菜单图标',
      customClass: 'upload-form',
      closeOnClickModal: false,
      showClose: false,
      message: h('div', {
        class: 'common-form-upload'
      }, [h('iconFrom', {
        on: {
          getIcon: function getIcon(n) {
            callback(n);
          }
        }
      })]),
      showCancelButton: false,
      showConfirmButton: false
    }).then(function () {
      resolve();
    }).catch(function () {
      reject();

      _this.$message({
        type: 'info',
        message: '已取消'
      });
    });
  });
}